module.exports = __webpack_public_path__ + "img/Logos-Footer-Mozaix.3e407896.png";